/**
 * 性別の列挙クラス
 * @param code : コード
 * @param name : 名称
 */
const _sex = [
  { "code": 0, "name": '不明'},
  { "code": 1, "name": '男性'},
  { "code": 2, "name": '女性'},
]

export default {
  data () {
    return {
      sex: _sex,
    }
  }
}

